<trp-community-widget *ngFor="let tile of tiles">
  <trp-community-widget-header
    [title]="tile.titleKey | translate"
    [icon]="tile.icon"
  ></trp-community-widget-header>
  <trp-community-widget-content>
    <div class="widget-content">
      <ng-container *ngIf="tile.available; else na">{{ tile.value }}</ng-container>
      <ng-template #na>
        <span>{{
          'widgets.singleFamilySolidWasteProgram.notice.noInformation' | translate
        }}</span>
      </ng-template>
    </div>
  </trp-community-widget-content>
</trp-community-widget>
